export enum DistributionFileUploadType {
	New = 1,
	Append = 2,
}
